const MODAL_SELECTOR = '.app-form-modal';

function getSamePageHash(trigger) {
  if (!(trigger instanceof HTMLAnchorElement)) return '';

  const targetUrl = new URL(trigger.href, window.location.href);
  const currentUrl = new URL(window.location.href);
  const targetsCurrentPage =
    targetUrl.origin === currentUrl.origin &&
    targetUrl.pathname === currentUrl.pathname &&
    targetUrl.search === currentUrl.search;

  return targetsCurrentPage && targetUrl.hash.length > 1 ? targetUrl.hash : '';
}

function syncModalWithHash() {
  const currentHash = window.location.hash;
  if (!currentHash) return;

  const modal = Array.from(document.querySelectorAll(MODAL_SELECTOR)).find(
    (candidate) => candidate.dataset.appFormModalHash === currentHash
  );
  if (typeof modal?.showDialog === 'function') modal.showDialog();
}

function replaceLocationHash(hash) {
  const url = new URL(window.location.href);
  url.hash = hash;
  window.history.replaceState(window.history.state, '', url);
}

export function configureAppFormModalTriggers(root = document) {
  root.querySelectorAll(`${MODAL_SELECTOR}[data-app-form-modal-trigger-selector]`).forEach((modal) => {
    const selector = modal.dataset.appFormModalTriggerSelector;
    if (!selector || !modal.id) return;

    let triggers;
    try {
      triggers = document.querySelectorAll(selector);
    } catch {
      return;
    }

    const dialogId = modal.querySelector('dialog')?.id;
    const hashes = new Set();
    triggers.forEach((trigger) => {
      trigger.dataset.appFormModalTrigger = '';
      trigger.dataset.appFormModalTarget = modal.id;
      trigger.setAttribute('aria-haspopup', 'dialog');
      if (dialogId) trigger.setAttribute('aria-controls', dialogId);

      const hash = getSamePageHash(trigger);
      if (hash) hashes.add(hash);
    });

    if (hashes.size === 1) {
      modal.dataset.appFormModalHash = hashes.values().next().value;
      if (!modal.dataset.appFormModalHashCloseConfigured) {
        modal.addEventListener('dialog:close', () => {
          if (window.location.hash === modal.dataset.appFormModalHash) replaceLocationHash('');
        });
        modal.dataset.appFormModalHashCloseConfigured = 'true';
      }
    }

    const replacedContentSelector = modal.dataset.appFormModalReplacedContentSelector;
    if (!replacedContentSelector) return;

    try {
      document.querySelectorAll(replacedContentSelector).forEach((element) => element.remove());
    } catch {
      // Invalid merchant-provided selectors leave the existing content unchanged.
    }
  });

  syncModalWithHash();
}

function findModal(trigger) {
  const targetId = trigger.dataset.appFormModalTarget;
  if (targetId) {
    const target = document.getElementById(targetId);
    if (target?.matches(MODAL_SELECTOR)) return target;
  }

  return trigger.closest('.shopify-section')?.querySelector(MODAL_SELECTOR);
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest('[data-app-form-modal-trigger]');
  if (!(trigger instanceof HTMLElement)) return;

  const modal = findModal(trigger);

  if (typeof modal?.showDialog !== 'function') return;

  event.preventDefault();

  const hash = getSamePageHash(trigger);
  if (hash && modal.dataset.appFormModalHash === hash) replaceLocationHash(hash);

  const dialogId = modal.querySelector('dialog')?.id;
  if (dialogId) trigger.setAttribute('aria-controls', dialogId);

  modal.showDialog();
});

window.addEventListener('hashchange', syncModalWithHash);

configureAppFormModalTriggers();
